import {
  IDataLoaderContext,
  ProductError,
} from '@masterofmalt/atom.componentlibrary/contexts/dataLoaderContext';
import { IProductModel } from '@masterofmalt/atom.componentlibrary/models/internal/product/IProductModel';
import DataLoader from 'dataloader';

import { getProductsBySku } from '../algolia/get-products-by-sku';

import { CacheWithExpiry } from './cache-with-expiry';
import { ActivePromotion } from './types/active-promotion';
import { PriceConfig } from './types/price-config';

const productDataLoaderCache = new Map<string, IDataLoaderContext['product']>();

const getProductDataLoaderKey = (priceConfig: PriceConfig): string =>
  Object.values(priceConfig).sort().join('-');

export const getProductDataLoaders = (
  priceConfig: PriceConfig,
  promotions: ActivePromotion[] = [],
): IDataLoaderContext['product'] => {
  const key = getProductDataLoaderKey(priceConfig);

  let productDataLoader = productDataLoaderCache.get(key);

  if (!productDataLoader) {
    productDataLoader = new DataLoader<number, IProductModel | ProductError, number>(
      async (productIds: readonly number[]) =>
        getProductsBySku(productIds, priceConfig, promotions),
      {
        maxBatchSize: 10,
        // Use our own cache to avoid products getting too stale.
        cacheMap: new CacheWithExpiry(300000), // 5 minutes
      },
    );

    productDataLoaderCache.set(key, productDataLoader);
  }

  return productDataLoader;
};

export const getDataLoaders = (
  priceConfig: PriceConfig,
  promotions: ActivePromotion[],
): IDataLoaderContext => {
  return {
    product: getProductDataLoaders(priceConfig, promotions),
  };
};
